import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as updateConfigurationActions from "../../../actions/updateConfigurationActions";
import * as uiActions from "../../../actions/uiActions";
import { Modal } from "../../../components/Modal";
import { ScrollListView } from "../../../components/ScrollListView";
import { PatternCard } from "./PatternCard";
import * as patternsService from "../../../services/patterns.service";
import * as _ from "lodash";
import { Carousel } from "../../../components/carousel";
import { patternCarouselSlides } from "./patternCarouselSlides";
import { OptionPanel } from "../components/OptionPanel";
import cn from "classnames";
import { isConfigRequested } from "../../../services/configurationWarningChecks"
import { TranslationContext } from "../../../context/TranslationContext";
import {introIsAvailable} from "../../helpers/introHelpers"
import {clickTheCanvas} from '../../helpers/config3dHelper';
import {resetLazyImageQueue} from '../../../components/LazyImage';
import { gtmPro } from "../../../services/gtmPro";

const limit = 24;
const defaultKeyWords = [
  "Animal",
  "Végétal",
  "Paysage",
  "Personnage",
  "Objet",
  "Symbole",
  'Accessoires'
];
const defaultState = {
  openPicker: false,
  selectedPatternIndex: null,
  query: "",
  keywords: [], // C'est la première recherche qui initialise les keywords par défaut
  patterns: [],
  total: 0,
  isLoadingMore:false
};

/**
 * Modal permettant de rechercher et choisir un motif à ajouter sur la face courante
 */
class PatternPickerComponent extends Component {
  static contextType = TranslationContext;
  static propTypes = {
    face: PropTypes.object.isRequired,
    drawing: PropTypes.bool,
    imprint: PropTypes.bool.isRequired,
    selectedPattern: PropTypes.object,
    patterns: PropTypes.array,
    patternToUpdate: PropTypes.bool
  };

  state = defaultState;
  searchInput;

  componentWillReceiveProps({ patterns, patternToUpdate }) {

    if (patternToUpdate && !this.state.openPicker) {
      const patternConfig = _.find(patterns, {
        reference: patternToUpdate.reference
      });
      this.openModalPicker(patternConfig.keywords.join(", "));
    }
  }

  toggleModalPicker = () => {
    if (this.state.openPicker) {
      this.closeModalPicker();
    } else {
      clickTheCanvas();
      this.openModalPicker();
      gtmPro().ctaOfConfiguration(
        {
          name: "extranet.config3d.config3d_patternandengravings_button_pattern",
          category: "configurateur",
          subcategory: "Motifs et Gravures",
          type: "cta",
          from: "left"
        },
        {template:"configurateur", subtemplate:"motifs&gravures"},
        {},
        "partner",
        "product",
        "user",
        "page"
      );
    }
  };
  handleScrollListMounted = (patterns) => {
    gtmPro().listPatterns(patterns);
  };

  toggleModalPickerForSimilarPattern = () => {
    if (this.state.openPicker) {
      this.closeModalPicker();
    } else {
      this.openModalPicker(
        this.props.selectedPattern &&
          this.props.selectedPattern.keywords.join(", ")
      );
    }
  };

  openModalPicker = async (query = "") => {
    await this.doSearch(query, []);

    this.setState({
      openPicker: true,
      query
    });
    
    !this.props.imprint &&
      setTimeout(() => this.searchInput && this.searchInput.focus());
  };

  patternNextPrevious = () =>{
    gtmPro().ctaOfConfiguration(
        {
          name: "next/previous",
          category: "configurateur",
          subcategory: "Motifs et Gravures",
          type: "picto",
          from: "right/left"
        },
        {template:"configurateur", subtemplate:"motifs&gravures"},
        {},
        "partner",
        "product",
        "user",
        "page"
      );
  }

  closeModalPicker = (button = null) => {
    //CHANGED this.setState(defaultState);
    if(button === "close") {
      gtmPro().closeModal();
    }
    resetLazyImageQueue();
    this.setState({openPicker: false,selectedPatternIndex: null});
    this.props.uiActions.closePatternPicker();
  };

  closeModalCarousel = () => {
    this.setState({
      selectedPatternIndex: null
    });
  };

  search = _.debounce(async () => {
    // On vide les résultats quand la recherche commence.
    // Cela provoque le scroll vers le haut de la liste et évite qu'un utilisateur
    // clique sur un motif qui vient d'être remplacé par le chargement des résultats
    // de recherche.
    this.setState({ patterns: [] });
    return await this.doSearch(this.state.query, []);
  }, 300);

  onClickKeyword = async keyword => {
    this.setState(
      {
        // query:keyword
        query: _.chain(this.state.query)
          .split(",")
          .map(_.trim)
          .filter() // Evite les keywords vides
          .concat(keyword)
          .uniq() // Evite qu'un double clique ajoute deux fois le keyword
          .value()
          .join(", ")
      },
      await this.search
    );
  };

  loadMore = async () => {
    if (this.state.patterns.length < this.state.total && !this.state.isLoadingMore) {
      gtmPro().ctaOfConfiguration(
        {
          name: "see_more_pattern",
          category: "configurateur",
          subcategory: "Motifs et Gravures",
          type: "cta",
          from: "bottom"
        },
        {template:"configurateur", subtemplate:"motifs&gravures"},
        {},
        "partner",
        "product",
        "user",
        "page"
      );
      this.isLoadingMore = true;
      await this.doSearch(this.state.lastQuery, this.state.patterns);
    }
  };

  doSearch =  async (query, patterns) => {
    let keywords = _.uniq([...this.state.keywords, ...defaultKeyWords]);
    if (this.props.imprint) {
        patternsService.getImprints().then(imprints=>{
        this.setState({ patterns: imprints, total: imprints.length,isLoadingMore:false});
        gtmPro().listPatterns(patterns.concat(imprints), this.state.query, keywords);
      });
    } else {
        patternsService.getPatterns(query,patterns.length,limit).then(result=>{
          // keywords = this.state.keywords.concat(query)
          keywords = _.uniq([...keywords, ...result.keywords]);
          this.setState({
            lastQuery: query,
            keywords: result.keywords.length ? result.keywords : defaultKeyWords,
            patterns: patterns.concat(result.patterns.list),
            total: result.patterns.total,
            isLoadingMore:false
          });
          gtmPro().listPatterns(patterns.concat(result.patterns.list), this.state.query, keywords);
        });
    }
  };

  renderItem = (pattern, index) => {
    return (
      <PatternCard
        key={index}
        pattern={pattern}
        onSelectPattern={() => this.onSelectPattern(index)}
      />
    );
  };

  onSelectPattern = index => {
    if (this.props.imprint) {
      this.onPickPattern(this.state.patterns[index]);
    } else {
      this.setState({
        selectedPatternIndex: index
      });
    }
    gtmPro().clickPattern(this.state.patterns[index])
  };

  onPickPattern = pattern => {
    const { face, patternToUpdate, actions } = this.props;
    if (patternToUpdate) {
      actions.updatePatternOfPattern(patternToUpdate.id, pattern);
    } else {
      actions.addPattern(face, pattern);
    resetLazyImageQueue();
    }
    gtmPro().ctaOfConfiguration(
        {
          name: "extranet.config3d.config3d_patternandengravings_button_pattern_add_pattern",
          category: "configurateur",
          subcategory: "Motifs et Gravures",
          type: "cta",
          from: "bottom"
        },
        {template:"configurateur", subtemplate:"motifs&gravures"},
        {},
        "partner",
        "product",
        "user",
        "page"
      );
    this.closeModalPicker();
  };

  seeSimilarPatterns = pattern => {
    gtmPro().ctaOfConfiguration(
        {
          name: "extranet.config3d.config3d_patternandengravings_button_pattern_similar",
          category: "configurateur",
          subcategory: "Motifs et Gravures",
          type: "cta",
          from: "bottom"
        },
        {template:"configurateur", subtemplate:"motifs&gravures"},
        {},
        "partner",
        "product",
        "user",
        "page"
      );
    this.setState({query:pattern.keywords});
    // this.state.query = pattern.keywords;
    this.search();
    this.closeModalCarousel();
  };

  searchBoxChange = event => {
    this.setState({ query: event.target.value }, this.search);
  };

  componentDidUpdate(prevProps, prevState) {
    const { modalName } = this.props;
    if (this.state.openPicker && this.state.openPicker !== prevState.openPicker && modalName) {
      setTimeout(() => {
        // this.props.launchIntro(true, modalName);
      }, 500)
    }
  }

  render() {
    const t = this.context;
    const { imprint, showIcon = true, modalName } = this.props;

    const header = (
      <>
        <div className="Header">
          <div className="HeaderContainer">
            <h1 className="Headline">
              {imprint
                ? t("config3d_patternandengravings_modal_reservation_locket_title") || "Sélectionnez un médaillon"
                : t("config3d_patternandengravings_modal_pattern_title") || "Rechercher un motif parmi plus de 1000 disponibles !"}
            </h1>
          </div>
        </div>
        {!imprint && (
          <div style={{"marginTop":"16px"}}>
            <form
              noValidate
              action=""
              onSubmit={event => {
                event.preventDefault();
                this.search();
              }}
            >
              <input
                ref={ref => (this.searchInput = ref)}
                type="text"
                placeholder={t("config3d_patternandengravings_modal_pattern_placeholder") || "Entrez vos mots-clés ou cliquez sur un thème"}
                value={this.state.query}
                onChange={this.searchBoxChange}
              />
            </form>
            <ul className="Keywords text-dark">
              {this.state.keywords.map((keyword, index) => (
                <li key={keyword}>
                  <div onClick={() => this.onClickKeyword(keyword)}>
                    {keyword}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );

    let scrollableFooter;
    if (
      this.state.patterns.length &&
      this.state.patterns.length < this.state.total
    ) {
      scrollableFooter = (
        <div className="More">
          <button onClick={() => this.loadMore()} className="button-primary button-medium">
            <span>{t("config3d_patternandengravings_modal_more_patterns") || "Voir plus de motifs"}</span>  
          </button>
        </div>
      );
    }

    const button = this.props.selectedPattern ? (
      <OptionPanel
        closeOnClickInside={true}
        className="AddPatternOptionPanel"
        buttonContent={ t("config3d_patternandengravings_button_pattern") || "Motifs" }
        buttonIcon="pattern2-icon"
        buttonClassName="btn-config-tertiary secondary2 text-light secondary2-hover secondary2-hover-border"
      >
        <button
          className="OptionPanelSquareItem secondary3-hover"
          onClick={this.toggleModalPicker}
        >
          Nouveau motif
        </button>
        <button
          className="OptionPanelSquareItem secondary3-hover"
          onClick={this.toggleModalPickerForSimilarPattern}
        >
          Motif similaire
        </button>
      </OptionPanel>
    ) : imprint ? (
      <button
        className="OptionPanelSquareItem secondary3-hover"
        onClick={this.toggleModalPicker}
      >
        {showIcon && <i className="icon material-icons">&#xE1AD;</i>}
        { t("config3d_patternandengravings_button_reservation_locket") || "Médaillon" }
      </button>
    ) : (
      <button
        className={`SquareButton ${this.props.buttonClassName ? this.props.buttonClassName : ''} ${isConfigRequested() && 'disabled'}`} 
        disabled={isConfigRequested()}
        onClick={this.toggleModalPicker}
      >
        {showIcon && <span className={`pattern2-icon icon`}></span> }
       <div>
        { t("config3d_patternandengravings_button_pattern") || "Motifs" }
       </div> 
      </button>
    );

    return (
      <div className="ModalButton">
        {button}

        <Modal
          isOpen={this.state.openPicker}
          onRequestClose={(val) => this.closeModalPicker(val)}
          className={cn("PatternPickerModal buttonModal background-page", {
            pattern: !imprint,
            imprint: imprint
          })}
          overlayClassName="PatternPickerModalOverlay" 
        >
          {introIsAvailable(false, modalName) && <span onClick={() => this.props.toggleSteps(this.props.modalName)} className="open-tutorial question-circle-icon icon icon-large"></span>}
          {header}
          <ScrollListView
            items={this.state.patterns}
            renderItem={this.renderItem}
            className="PatternPicker"
            scrollableFooter={scrollableFooter}
            query={this.state.query}
            // onItemsChange={() => this.handleScrollListMounted(this.state.patterns)}
          />
        </Modal>

        <Modal
          isOpen={this.state.selectedPatternIndex !== null}
          onRequestClose={this.closeModalCarousel}
          className="PatternModal"
          overlayClassName="PatternModalOverlay"
        >
          <Carousel
            slidesData={this.state.patterns}
            slideToShow={this.state.selectedPatternIndex}
            renderSlide={this.makePatternSlideRenderer(t)}
            patternNextPrevious= {this.patternNextPrevious}
          />
        </Modal>
      </div>
    );
  }

  makePatternSlideRenderer = (t) =>
    patternCarouselSlides({
      patterns: this.state.patterns,
      loadMore: this.loadMore,
      seeSimilarPatterns: this.seeSimilarPatterns,
      onPickPattern: this.onPickPattern,
      isUpdate: this.props.patternToUpdate,
      imprint: this.props.imprint,
      t
    });
}

export const PatternPicker = connect(
  state => ({
    patterns: state.configurator.current.patterns,
    patternToUpdate: state.ui.patternPicker
  }),
  dispatch => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch),
    uiActions: bindActionCreators(uiActions, dispatch)
  })
)(PatternPickerComponent);
